import { render, staticRenderFns } from "./MailEdit.vue?vue&type=template&id=41564e92&scoped=true&"
import script from "./MailEdit.vue?vue&type=script&lang=ts&"
export * from "./MailEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MailEdit.vue?vue&type=style&index=0&id=41564e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41564e92",
  null
  
)

export default component.exports